import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy address kept for old bookmarks. The feature is now called
// "Notyfikacje" in the UI and lives under /notifications.
export const Route = createFileRoute("/_authenticated/promotions")({
  beforeLoad: () => {
    throw redirect({ to: "/notifications", replace: true });
  },
});
